<template>
  <li class="tw-list-none">
    <button :class="buttonClass" @click="emitClick" :data-test-id="testId">
      <slot></slot>
    </button>
  </li>
</template>

<script lang="ts" setup>
import { toRefs, computed } from "vue";

export interface DropdownItemProps {
  active?: boolean;
  disabled?: boolean;
  testId?: string;
}

const props = withDefaults(defineProps<DropdownItemProps>(), {
  active: false,
  disabled: false,
  testId: "cl-raised-tab",
});

const { active, disabled } = toRefs(props);

const buttonClass = computed(() => {
  return [
    "tw-inline-block  tw-px-3 tw-py-2 tw-rounded-t-md tw-text-nowrap",
    disabled.value
      ? "tw-pointer-events-none tw-text-primary-grey-200 tw-border-gray-200"
      : "tw-text-primary-grey-700 tw-border-primary-grey-700",
    active.value
      ? "tw-border tw-border-b-0  tw-text-primary-grey-700 tw-font-semibold hover:tw-cursor-default"
      : "tw-border-b tw-font-medium hover:tw-bg-primary-grey-50 hover:tw-text-primary-grey-700 hover:tw-cursor-pointer",
  ];
});

const emit = defineEmits<{
  (event: "on-click"): void;
}>();

const emitClick = (): void => {
  emit("on-click");
};
</script>
